var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.795H9",
    stroke: "#FCFCFD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16498 10.125H7.33502C8.67002 10.125 9 10.455 9 11.775V14.8575C9 16.1775 8.67002 16.5075 7.33502 16.5075H3.16498C1.82998 16.5075 1.5 16.1775 1.5 14.8575V11.775C1.5 10.455 1.82998 10.125 3.16498 10.125Z",
    stroke: "#FCFCFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.25C16.5 14.1525 14.1525 16.5 11.25 16.5L12.0375 15.1875",
    stroke: "#FCFCFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.75C1.5 3.8475 3.8475 1.5 6.75 1.5L5.96251 2.8125",
    stroke: "#FCFCFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 8.25C15.739 8.25 17.25 6.73896 17.25 4.875C17.25 3.01104 15.739 1.5 13.875 1.5C12.011 1.5 10.5 3.01104 10.5 4.875C10.5 6.73896 12.011 8.25 13.875 8.25Z",
    stroke: "#FCFCFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertIcon);
export default __webpack_public_path__ + "static/media/convertIcon.aee188baa067490819414f1e078074f7.svg";
export { ForwardRef as ReactComponent };